import * as React from 'react';
const SvgArticle = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M4.757 16.584q-.564 0-.952-.389a1.3 1.3 0 0 1-.388-.951V4.757q0-.562.388-.951.389-.39.952-.389h10.487q.563 0 .95.389.39.389.39.95v10.488q0 .563-.39.951-.387.39-.95.389zm0-1.084h10.487a.25.25 0 0 0 .176-.08.25.25 0 0 0 .08-.176V4.757a.25.25 0 0 0-.08-.176.25.25 0 0 0-.176-.08H4.757a.25.25 0 0 0-.177.08.25.25 0 0 0-.08.176v10.487q0 .096.08.176t.177.08m1.993-1.708h4.5a.526.526 0 0 0 .542-.537.53.53 0 0 0-.156-.388.52.52 0 0 0-.386-.158h-4.5a.526.526 0 0 0-.542.537q0 .228.156.387a.52.52 0 0 0 .386.159m0-3.25h6.5a.526.526 0 0 0 .542-.537.53.53 0 0 0-.156-.388.52.52 0 0 0-.386-.158h-6.5a.526.526 0 0 0-.542.537q0 .228.156.387a.52.52 0 0 0 .386.159m0-3.25h6.5a.526.526 0 0 0 .542-.537.53.53 0 0 0-.156-.388.52.52 0 0 0-.386-.158h-6.5a.526.526 0 0 0-.542.537q0 .229.156.387a.52.52 0 0 0 .386.159'
            />
        </g>
    </svg>
);
export default SvgArticle;
